export default __webpack_public_path__ + "static/media/apiFailed-dark.b7cffdcb.svg";